export enum DocumentActions {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}
